import { SystemReceiveMessageType } from "@/resources/constants/graphicClient/graphicClient";
import { Store } from "vuex";
import { mixins } from "vue-class-component";
import Loader from "@/resources/mixins/loader/loader";
import { i18n } from "@/resources/locales";
import LoadApp from "@/resources/mixins/loadApp/loadApp";
import EnterNubiiAnimation from "@/resources/mixins/animations/enterNubiiAnimation";
import { MIX_PANEL_CONSTANTS } from "../../constants/mixpanel";

export default class SystemHandler extends mixins(
  Loader,
  LoadApp,
  EnterNubiiAnimation
) {
  async sendServerPing(store: Store<any>, user: any) {
    setTimeout(() => {
      if (user)
        store?.dispatch("UserStore/sendServerPingAction",
          {
            spaceUserId: user.id,
            callback: async (response) => {},
            callbackError: (error) => {
              console.log("SystemHandler sendServerPing KO ", error);
            },
          }
        );
      this.sendServerPing(store, user);
    }, 600000);
  }
  async handleMessage(
    message: string,
    value?: any | null,
    store?: Store<any>,
    mixpanel?
  ): Promise<void> {
    switch (message) {
      case SystemReceiveMessageType.SYSTEM_GRAPHIC_CLIENT_LOAD_COMPLETE: {
        await this.stopLoader(store);
        if (!value) {
          //TODO modal informando de que nose puede cargar el espacio.
          console.log("ERROR SYSTEM_GRAPHIC_CLIENT_LOAD_COMPLETE");
        } else {
          const user = store?.getters["UserStore/getSpaceUser"];
          if (!user) return;
          if (user)
            await store?.dispatch(
              "SystemStore/setShowWelcomeAction",
              user.superSpaceUser.user.isFirstTime
            );
          let active = localStorage.getItem("space_label") == "true";
          if (!localStorage.getItem("space_label")) {
            active = true;
          }
          store?.dispatch("GraphicClientStore/setLabelToggleAction", active);
          if (user) {
            store?.dispatch(
              "SystemStore/setShowGoodMorningModalAction",
              !user.superSpaceUser.user.isFirstTime
            );
            if (!user.superSpaceUser.user.isFirstTime)
              this.sendServerPing(store, user);
          }
          /* Activa el bounce en el notch*/
          const clickCameraOptions =
            localStorage.getItem("click_camera_options") === "true";
          if (
            user &&
            !user.superSpaceUser.user.isFirstTime &&
            !clickCameraOptions
          ) {
            const container = document.getElementById("camera-container");
            if (container) {
              container.addEventListener("click", () => {
                localStorage.setItem("click_camera_options", "true");
                container.setAttribute("class", "camera-options-container ");
              });
              container.setAttribute(
                "class",
                "camera-options-container activeAnimation "
              );
            }
          }
        }
        break;
      }
      case SystemReceiveMessageType.SYSTEM_GRAPHIC_CLIENT_READY_EVENT: {
        const city = localStorage.getItem("city") == "ON" ? true : false;
        await store?.dispatch(
          "SystemStore/setGraphicClientVersionAction",
          value
        );
        const user = store?.getters["UserStore/getSpaceUser"];
        const hasOnboarding = !localStorage.getItem("hasOnboarding")
          ? true
          : localStorage.getItem("hasOnboarding") === "true";
        if (user && user.superSpaceUser.user.isFirstTime && hasOnboarding) {
          const space = store?.getters["SpaceStore/getSpace"];
          mixpanel.track(MIX_PANEL_CONSTANTS.LAND_IN_SPACE, {
            distinct_id: user.superSpaceUser.user.id,
            "Space ID": space.id || localStorage.getItem("space_default"),
            "Space Name": space.name || null,
            "Space Type": space.type || null,
            "Scenario Name": space.scenario.scenarioType.name || null,
            "Super Space Name": space.superSpace.name || null,
            "Super Space ID": space.superSpace.id || null,
          });
          await store?.dispatch(
            "GraphicClientStore/initializeUserOnBoardingAction"
          );
        } else if (city) {
          if (user && user.superSpaceUser.user.isFirstTime) {
            const space = store?.getters["SpaceStore/getSpace"];
            mixpanel.track(MIX_PANEL_CONSTANTS.LAND_IN_SPACE, {
              distinct_id: user.superSpaceUser.user.id,
              "Space ID": space.id || localStorage.getItem("space_default"),
              "Space Name": space.name || null,
              "Space Type": space.type || null,
              "Scenario Name": space.scenario.scenarioType.name || null,
              "Super Space Name": space.superSpace.name || null,
              "Super Space ID": space.superSpace.id || null,
            });
          }
          await store?.dispatch("SuperSpaceStore/getSuperSpacesAction", {
            pagination: false,
            callback: async (response) => {
              this.stopLoader(store);
              /*  await store?.dispatch(
                "GraphicClientStore/initializeCityAction",
                response.data
              ); */
            },
            callbackError: (error) => {
              console.log("City On ", error);
            },
          });
        } else {
          if (user && user.superSpaceUser.user.isFirstTime) {
            const space = store?.getters["SpaceStore/getSpace"];
            mixpanel.track(MIX_PANEL_CONSTANTS.LAND_IN_SPACE, {
              distinct_id: user.superSpaceUser.user.id,
              "Space ID": space.id || localStorage.getItem("space_default"),
              "Space Name": space.name || null,
              "Space Type": space.type || null,
              "Scenario Name": space.scenario.scenarioType.name || null,
              "Super Space Name": space.superSpace.name || null,
              "Super Space ID": space.superSpace.id || null,
            });
          }
          await store?.dispatch(
            "GraphicClientStore/initializeUserAndSpaceAction"
          );
        }
        break;
      }
      case SystemReceiveMessageType.SYSTEM_GRAPHIC_CLIENT_OPEN_WONDER_POINT: {
        if (!value.openUrlExternally) {
          window.open(value.url, "_blank").focus();
        } else {
          store?.dispatch("SystemStore/setWonderPointUrlAction", value.url);
          store?.dispatch("SystemStore/setOpenWonderPointModalAction", true);
        }
        break;
      }
      case SystemReceiveMessageType.SYSTEM_GRAPHIC_CLIENT_OPEN_HELP_POINT: {
        store?.dispatch("FloatMenuStore/setOpenHelpBotAction", true);
        break;
      }
      case SystemReceiveMessageType.SYSTEM_GRAPHIC_CLIENT_OPEN_MENU_CHANGE_SPACE_AND_EXIT: {
        this.startLoader(store);
        await store.dispatch("SpaceStore/setSpacesAvailablePageAction", 1);
        await store.dispatch("SpaceStore/setLastPageSpacesAction", 2);

        await store.dispatch("SpaceStore/getSpacePaginateAction", {
          id: value,
          callback: (response) => {
            if (response.length == 1) {
              localStorage.setItem("space_default", "");
              localStorage.setItem("city", "ON");
              window.location.reload();
            } else {
              store.dispatch("SystemStore/setSelecSuperSpaceIdAction", value);
              store.dispatch("SystemStore/setOpenChangeSpaceModalAction", true);
            }
          },
          callbackError: (error) => {
            console.log(error);
          },
        });
        //Todo antigua logica
        /*const spaces = store?.getters["SpaceStore/getSpacesAvailable"];
        if (spaces.length > 1)
          store?.dispatch("SystemStore/setOpenChangeSpaceModalAction", true);
        else {
          store?.dispatch("SystemStore/setShowExitModalAction", true);
        }*/
        break;
      }
      case SystemReceiveMessageType.SYSTEM_GRAPHIC_CLIENT_PHOTON_ERROR: {
        store?.dispatch("SystemStore/setShowPhotonErrorModalAction", true);
        break;
      }
      case SystemReceiveMessageType.SYSTEM_GRAPHIC_SET_ZOOM: {
        store?.dispatch("SystemStore/setZoomAction", value);
        break;
      }
      case SystemReceiveMessageType.SYSTEM_GRAPHIC_SET_MAX_ZOOM: {
        store?.dispatch("SystemStore/setMaxZoomAction", value);
        break;
      }
      case SystemReceiveMessageType.SYSTEM_GRAPHIC_SET_MIN_ZOOM: {
        store?.dispatch("SystemStore/setMinZoomAction", value);
        break;
      }
      case SystemReceiveMessageType.SYSTEM_DESCRIPTION_BOOTH_ACTIVE: {
        document.body.style.cursor = "pointer";
        /*const timeOut =
          store?.getters["SystemStore/getDescriptionBoothTimeOut"];
        store?.dispatch(
          "SystemStore/setDescriptionBoothCountDownModalAction",
          false
        );
        clearTimeout(timeOut);
        store?.dispatch("SystemStore/setDescriptionBoothTimeOutAction", null);
        store?.dispatch("SystemStore/setDescriptionBoothModalAction", true);
        store?.dispatch(
          "SystemStore/setDescriptionBoothModalDataAction",
          value
        );*/
        break;
      }
      case SystemReceiveMessageType.SYSTEM_DESCRIPTION_BOOTH_DISABLE: {
        document.body.style.cursor = "default";
        /*const timeOut =
          store?.getters["SystemStore/getDescriptionBoothTimeOut"];
        clearTimeout(timeOut);
        store?.dispatch(
          "SystemStore/setDescriptionBoothCountDownModalAction",
          true
        );
        const timeout = setTimeout(() => {
          store?.dispatch("SystemStore/setDescriptionBoothModalAction", false);
        }, 3000);
        store?.dispatch(
          "SystemStore/setDescriptionBoothTimeOutAction",
          timeout
        );*/
        break;
      }
      case SystemReceiveMessageType.SYSTEM_DESCRIPTION_BOOTH_CLICK: {
        store?.dispatch("SystemStore/setDescriptionBoothModalAction", true);
        store?.dispatch(
          "SystemStore/setDescriptionBoothModalDataAction",
          value
        );
        break;
      }
      case SystemReceiveMessageType.SYSTEM_UPDATE_USER_POSITION: {
        const user = store?.getters["UserStore/getSpaceUser"];
        store?.dispatch("UserStore/saveSpaceUserPositionAction", {
          userId: user.id,
          props: {
            position: {
              x: value.x,
              y: value.y,
              z: value.z,
            },
          },
          callback: (response) => {
            let props = value;
            store?.dispatch("UserStore/setPositionAction", props);
          },
          callbackError: (error) => { },
        });
        break;
      }
      case SystemReceiveMessageType.SYSTEM_GRAPHIC_CLIENT_ONBOARDING_STEP_COMPLETED: {
        switch (value) {
          case 1: {
            const audio = new Audio(require("@/assets/audio/correct.mp3"));
            await audio.play();
            /*store?.dispatch(
              "SystemStore/setTutorialTextAction",
              i18n.t("tutorial.stepComplete")
            );*/
            /*setTimeout(() => {*/
            store?.dispatch("SystemStore/setTutorialTextAction", 2);
            /* }, 2000);*/
            break;
          }
          case 2: {
            const audio = new Audio(require("@/assets/audio/correct.mp3"));
            await audio.play();
            store?.dispatch("MeetingStore/setOpenDevicesConfigAction", true);
            setTimeout(() => {
              store?.dispatch("SystemStore/setTutorialTextAction", 3);
            }, 2000);
            break;
          }
          case 3: {
            const audio = new Audio(require("@/assets/audio/correct.mp3"));
            await audio.play();
            store?.dispatch("SystemStore/setTutorialTextAction", 4);
            setTimeout(async () => {
              const user = store.getters["UserStore/getSpaceUser"];
              await store.dispatch("UserStore/updateUserAction", {
                userId: user.superSpaceUser.user.id,
                props: {
                  isFirstTime: false,
                },
                callback: async (user) => {
                  await store.dispatch(
                    "SystemStore/setShowCompleteOnBoardingAction",
                    false
                  );
                  await store.dispatch(
                    "SystemStore/setShowCompleteOnBoardingTeamsAction",
                    false
                  );
                  await store?.dispatch(
                    "SystemStore/setShowTutorialModalAction",
                    false
                  );
                  const notificationTutorial =
                    store?.getters["SystemStore/getTutorialNotification"];
                  if (notificationTutorial) notificationTutorial.close();
                  setTimeout(async () => {
                    //Buscar otra manera de cargar el store.
                    await this.setStore(store);
                    await this.loadFirstTime();

                    store?.dispatch(
                      "SystemStore/setShowTutorialModalAction",
                      false
                    );
                  }, 2000);
                },
              });
            }, 2000);
          }
        }
        break;
      }
      case SystemReceiveMessageType.WEBGL_CONTEXT_LOST: {
        store?.dispatch("SystemStore/setShowWebGLContextLostModalAction", true);
        break;
      }
      case SystemReceiveMessageType.SYSTEM_LOAD_SUPER_SPACE: {
        this.startLoader(store);
        await store.dispatch("SpaceStore/setSpacesAvailablePageAction", 1);
        await store.dispatch("SpaceStore/setLastPageSpacesAction", 2);

        await store.dispatch("SpaceStore/getSpacePaginateAction", {
          id: value,
          callback: (response) => {
            if (response.length == 1) {
              localStorage.setItem("space_default", response[0].id.toString());
              localStorage.setItem("city", "OFF");
              window.location.reload();
            } else {
              store.dispatch("SystemStore/setSelecSuperSpaceIdAction", value);
              store.dispatch("SystemStore/setOpenChangeSpaceModalAction", true);
            }
          },
        });
        break;
      }
      case SystemReceiveMessageType.SYSTEM_SHOW_PIN_INFO: {
        const timeOut = store?.getters["SystemStore/getPinTimeOut"];

        store?.dispatch("SystemStore/setShowPinModalAction", false);
        store?.dispatch("SuperSpaceStore/setSuperSpaceAction", null);
        setTimeout(() => {
          store?.dispatch("SystemStore/setPinCountDownModalAction", false);
          clearTimeout(timeOut);
          store?.dispatch("SystemStore/setPinTimeOutAction", null);
          store?.dispatch(
            "SystemStore/setSelectedPinSuperSpaceIdAction",
            value
          );
          store?.dispatch("SystemStore/setShowPinModalAction", true);
        }, 300);

        break;
      }
      case SystemReceiveMessageType.SYSTEM_HIDE_PIN_INFO: {
        const timeOut = store?.getters["SystemStore/getPinTimeOut"];
        clearTimeout(timeOut);
        store?.dispatch("SystemStore/setPinCountDownModalAction", true);
        const timeout = setTimeout(() => {
          store?.dispatch("SystemStore/setShowPinModalAction", false);
        }, 3000);
        store?.dispatch("SystemStore/setPinTimeOutAction", timeout);
        break;
      }
      case SystemReceiveMessageType.SYSTEM_POSTER_ACTIVE: {
        document.body.style.cursor = "pointer";
        break;
      }
      case SystemReceiveMessageType.SYSTEM_POSTER_DISABLE: {
        document.body.style.cursor = "default";
        break;
      }
      case SystemReceiveMessageType.SYSTEM_POSTER_CLICK: {
        store?.dispatch("SpaceStore/getPosterAction", {
          id: value,
          callback: (response) => {
            if ((response.url && response.url !== "") || (response.videoUrl && response.videoUrl !== "")) {
              store.dispatch("SystemStore/setShowPosterAction", response);
              store.dispatch("SystemStore/setOpenPosterModalAction", true);
            }
          },
        });
        break;
      }
      case SystemReceiveMessageType.SYSTEM_GENERAL_ERROR: {
        store.dispatch("SystemStore/setErrorDataGeneralClientGraphicAction", value);
        store.dispatch("SystemStore/setErrorGeneralClientGraphicAction", true);
        this.stopLoader(this.$store);
        break;
      }
      case SystemReceiveMessageType.SYSTEM_BIRTHDAY_ACTIVE: {
        store.dispatch("SystemStore/setDataBirthdayModalAction", value);
        store.dispatch("SystemStore/setShowBirthdayModalAction", true);
        break;
      }
      case SystemReceiveMessageType.SYSTEM_ROBOT_ACTIVE: {
        store.dispatch("SystemStore/setAssistantAction", null);
        const space = store.getters["SpaceStore/getSpace"];
        if (space && space.superSpace && space.superSpace.company == "HAWKINGS") {
          store.dispatch("SystemStore/setEducationBotIdAction", value);
          store.dispatch("SystemStore/setEducationModalAction", true);
        }
        else if (value) {
          store.dispatch("SystemStore/setAssistantAction", value);
          store.dispatch("SystemStore/setRobotModalAction", true);
        }
        else
          store.dispatch("SystemStore/setRobotModalAction", true);
        break;
      }
      case SystemReceiveMessageType.SYSTEM_GAME_KILL: {
        await store.dispatch("GameKillerStore/killPlayerGameKillerAction", {
          spaceUserId: value,
          callback: async (response) => {
          },
          callbackError: (error) => {
            console.log("TTT KO", error);
          },
        });
        break;
      }
      default: {
        console.error(
          `${message} is not defined in systemMessageHandler method`
        );
        break;
      }
    }
  }
}
